var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMt4Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 49.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e58613;}.cls-2{fill:#fff;}.cls-3{fill:none;}.cls-4{fill:#678925;}.cls-5{fill:#2f6fa8;}.cls-6{fill:#c1a840;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mt4_fbs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mt4_fbs"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.99,
    cy: 28.16,
    r: 12.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.99,
    cy: 28.16,
    r: 9.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.68,31.44H27.24v2.48H24.78V31.44h-5V29.68L24.92,22h2.32v7.53h1.44Zm-3.9-2V27.14c0-.14,0-.29,0-.46s0-.34,0-.52l0-.52c0-.16,0-.3,0-.43s0-.21,0-.26h-.07l-.33.73c-.12.25-.27.51-.42.77l-2,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.32,27.55a17,17,0,0,1,3.14-.84,13.7,13.7,0,0,1,.62-2.8C10.71,24.56,8.26,26.66,8.32,27.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,42.51a17.8,17.8,0,0,1-2.05-2,13.72,13.72,0,0,1-2.42.91C30,42.17,32.4,42.93,33,42.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.65,14a17.44,17.44,0,0,1-.84,3.11,13.08,13.08,0,0,1,2.11,1.82C35,17.35,34.42,14.36,33.65,14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 25.03,
    cy: 6.06,
    rx: 4.89,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.81,17.09A17.44,17.44,0,0,0,33.65,14c.77.38,1.35,3.37,1.27,4.93a13.59,13.59,0,0,1,3.69,8.67C40.21,25.15,44.9,8.2,30.75,4c.76,8.32-4.91,9.26-5.57,9.28s-6.81-.77-6-9.13C9.88,6.18,9.1,14.74,9.37,17.88a15.62,15.62,0,0,1,6.58-2A4.38,4.38,0,0,1,16.88,14c0,.74.05,1.16.06,1.77.45-.06,1.65-.18,3.21-.24a13.61,13.61,0,0,1,12.66,1.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 44.21,
    cy: 39.01,
    rx: 4.89,
    ry: 6.06,
    transform: "translate(-11.68 57.78) rotate(-59.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.85,35.5c.34-.6,4.07-5.51,10.89-.6,2.94-9.08-4.08-14-6.94-15.37a15.4,15.4,0,0,1-1.52,6.72A4.47,4.47,0,0,1,41.43,28l-1.57-.83c-.17.41-.64,1.46-1.34,2.8A13.64,13.64,0,0,1,31,40.49a17.8,17.8,0,0,0,2.05,2c-.64.42-3-.34-4.47-1.11a13.71,13.71,0,0,1-9.45-.86C21.51,44,33,54.55,43.1,45,35.51,41.47,37.53,36.08,37.85,35.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11,35.94c-1.36-2.34-4.8-2.87-7.7-1.2S-.81,39.67.55,42s4.8,2.88,7.69,1.2S12.38,38.28,11,35.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.37,28.25c0-.52,0-1,.09-1.54a17,17,0,0,0-3.14.84c-.06-.89,2.39-3,3.76-3.64a13.58,13.58,0,0,1,3.79-5.77,11.22,11.22,0,0,1,2-1.67C16,16-2.44,20.19,1.18,35c6.81-4.83,10.47-.4,10.81.17S14.75,41.48,7.1,45C13.49,52,21.29,48.41,23.88,46.6a15.4,15.4,0,0,1-5.07-4.67,4.67,4.67,0,0,1-2.08.13l1.5-1c-.22-.29-.72-1-1.33-1.91A13.6,13.6,0,0,1,11.37,28.25Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt4Logo);
export default __webpack_public_path__ + "static/media/mt4_logo.ed50322cf2778c9ddb8d7aef510b4170.svg";
export { ForwardRef as ReactComponent };